import p from "../../@babel/runtime/helpers/esm/typeof2.mjs";
import { version as a } from "react";
import "../../react-is/index.mjs";
import c from "./hooks/useMemo.mjs";
import { exports as u } from "../../../_virtual/index2.mjs";
var m = function(o, n) {
  typeof o == "function" ? o(n) : p(o) === "object" && o && "current" in o && (o.current = n);
}, s = function() {
  for (var o = arguments.length, n = new Array(o), t = 0; t < o; t++)
    n[t] = arguments[t];
  var e = n.filter(Boolean);
  return e.length <= 1 ? e[0] : function(r) {
    n.forEach(function(f) {
      m(f, r);
    });
  };
}, h = function() {
  for (var o = arguments.length, n = new Array(o), t = 0; t < o; t++)
    n[t] = arguments[t];
  return c(function() {
    return s.apply(void 0, n);
  }, n, function(e, r) {
    return e.length !== r.length || e.every(function(f, i) {
      return f !== r[i];
    });
  });
}, R = function(o) {
  var n, t, e = u.isMemo(o) ? o.type.type : o.type;
  return !(typeof e == "function" && !((n = e.prototype) !== null && n !== void 0 && n.render) && e.$$typeof !== u.ForwardRef || typeof o == "function" && !((t = o.prototype) !== null && t !== void 0 && t.render) && o.$$typeof !== u.ForwardRef);
};
Number(a.split(".")[0]) >= 19;
export {
  s as composeRef,
  m as fillRef,
  R as supportRef,
  h as useComposeRef
};
//# sourceMappingURL=ref.mjs.map
